import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import './LaptopQuizPage.css';

class LaptopQuizPage extends Component {
  render() {
    return (
      <div className="Regular-page ui stackable center aligned padded column grid">
        <div className="one wide column">
        </div>

        <div className="ten wide column center aligned">
          as;dlfj asldfjas;lfjl;asfjl;asdfj asdl;fj as;lf jasdlf jafd
        </div>

        <div className="one wide column">
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({

  }),
  {

  }
)(LaptopQuizPage);


// WEBPACK FOOTER //
// ./src/components/LaptopQuizPage/LaptopQuizPage.js